export default "__VITE_ASSET__B4IYtvm5__"